export default __webpack_public_path__ + "static/media/img_ai_tutorial_banner.170c947e.png";